<template>
  <div class="footer"><!-- footer -->
    <win-layer-pop class="footer-pop">
      <component
        v-if="customComponent"
        :is="customComponent"
        @close="closePopup"
      />
    </win-layer-pop>
    <div class="inner_footer">
      <div class="wrap_address">
        <span class="logo_foot"></span>
        <p class="address">{{ $t('footer.addr') }} <span class="tel">{{ $t('footer.tel') }}</span></p>
        <p class="copyright">2022 KOREA MARINE TRANSPORT CO. LTD</p>
      </div>

      <div class="wrap_address" v-if="serviceLang == 'CHN'">
        <a style="color:#fff; opacity: 0.6;  font-size:11px;" href="https://beian.miit.gov.cn"   target="_blank;">{{ icpNo }}</a> <br><br>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010902002679"  target="_blank;">
          <img src="/img/ICP.png" />
        </a>
      </div>

      <div class="wrap_rightarea">

        <ul class="link">
          <li><a href="#" @click.prevent="openPopup('inform-handle-policy-pop')">{{ $t('footer.privacy') }}</a></li>
          <li><a href="#" @click.prevent="openPopup('email-collect-refuse-pop')">{{ $t('footer.email_deny') }}</a></li>
          <li><a href="#" @click.prevent="goContactUs()">CONTACT US</a></li>
        </ul>

        <div>
        </div>
      </div><!-- footer // -->
    </div>
  </div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/helpers'
import { ekmtcTld } from '@/api/serviceDomain'

export default {
  name: 'layout-footer',
  components: {
    'win-layer-pop': () => import('@/pages/trans/popup/WinLayerPop'),
    'email-collect-refuse-pop': () => import('@/pages/common/popup/EmailCollectRefusePop'),
    'inform-handle-policy-pop': () => import('@/pages/common/popup/InformHandlePolicyPop')
  },
  data: function () {
    return {
      customComponent: null
    }
  },
  computed: {
    ...rootComputed,
    // ICP 비안번호: .com.cn 도메인은 -4, 그 외(.com 등)는 -2
    icpNo () {
      return ekmtcTld() === '.com.cn' ? '沪ICP备12037401号-4' : '沪ICP备12037401号-2'
    }
  },
  methods: {
    goContactUs () {
      this.$router.push({ name: 'network', query: {} }).catch(() => {})
    },
    // 팝업 열기
    openPopup (cmpNm) {
      this.customComponent = cmpNm
      this.$ekmtcCommon.layerOpen('.footer-pop')
    },
    // 팝업 닫기
    closePopup () {
      this.customComponent = null
      this.$ekmtcCommon.layerClose('.footer-pop')
    }
  }
}
</script>
